module.exports = __webpack_public_path__ + "img/NPVterminal_dcf.650a0bf9.svg";